import { Inject, Injectable, Optional, signal } from "@angular/core";
import { UAParser } from "ua-parser-js";
import { PlatformService } from "../platform/platform.service";
import { REQUEST } from "@src/express.tokens";
import { Observable, ReplaySubject } from "rxjs";
//import { isPlatformServer } from '@angular/common';

// Definimos una clave para TransferState
//const DEVICE_KEY = makeStateKey<boolean>('isMobile');
@Injectable({
  providedIn: "root",
})

/**
 * Servicio que se encarga de obtener información sobre el dispositivo del usuario.
 */
export class DeviceService {
  // Variable privada para almacenar el dispositivo.
  private device: UAParser;
  // Subject para controlar si el dispositivo es móvil.
  private _isMobile: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  deviceIsMobile = signal<boolean | undefined>(undefined);

  constructor(
    private platformService: PlatformService,
    @Optional() @Inject(REQUEST) private request: Request,
  ) {
    let parser: UAParser;

    if (this.platformService.isBrowser()) {
      parser = new UAParser(window.navigator.userAgent);
    } else if (this.request) {
      parser = new UAParser(this.request.headers["user-agent"]);
    } else {
      parser = new UAParser();
    }

    this.device = parser;
    const device = parser.getDevice();

    this._isMobile.next(device.type === "mobile");
  }
  // export class DeviceService {
  //   // Variable para almacenar la información del dispositivo.
  //   private device: UAParser;
  //   // Subject para emitir el valor si es móvil o no.
  //   private _isMobile: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  //   constructor(
  //     private platformService: PlatformService,
  //     @Optional() @Inject(REQUEST) private request: Request,
  //     private transferState: TransferState,
  //     @Inject(PLATFORM_ID) private platformId: object
  //   ) {
  //     let parser: UAParser;
  //     let isMobile = false; // Valor que determinaremos según el entorno

  //     if (this.platformService.isBrowser()) {
  //       // En el cliente, primero comprobamos si TransferState ya tiene el valor
  //       if (this.transferState.hasKey(DEVICE_KEY)) {
  //         isMobile = this.transferState.get(DEVICE_KEY, false);
  //         // Eliminamos la clave para liberar memoria
  //         this.transferState.remove(DEVICE_KEY);
  //         // Creamos el parser a partir del userAgent del navegador (opcional)
  //         parser = new UAParser(window.navigator.userAgent);
  //       } else {
  //         // Si no existe el valor transferido, lo determinamos en el cliente
  //         parser = new UAParser(window.navigator.userAgent);
  //         const device = parser.getDevice();
  //         isMobile = device.type === 'mobile';
  //       }
  //     } else if (isPlatformServer(this.platformId) && this.request) {
  //       // En el servidor, obtenemos el user-agent desde el request
  //       parser = new UAParser(this.request.headers['user-agent']);
  //       const device = parser.getDevice();
  //       isMobile = device.type === 'mobile';
  //       // Guardamos el valor en TransferState para que el cliente lo pueda leer
  //       this.transferState.set(DEVICE_KEY, isMobile);
  //     } else {
  //       // Caso fallback si no se puede determinar el entorno
  //       parser = new UAParser();
  //       const device = parser.getDevice();
  //       isMobile = device.type === 'mobile';
  //     }

  //     this.device = parser;
  //     this._isMobile.next(isMobile);
  //   }

  /**
   * Devuelve el sistema operativo del dispositivo.
   * @returns Sistema operativo del dispositivo.
   */
  public getOS(): any {
    return this.device.getOS();
  }

  /**
   * Devuelve un booleano que indica si el dispositivo es móvil.
   * @returns {boolean} - Booleano que indica si el dispositivo es móvil.
   */
  public isMobile(): Observable<boolean> {
    return this._isMobile.asObservable();
  }
}
